export const arrayToSelectValue = (data, pr) => {
  if (!data) {
    return
  }

  return data.map((item) => ({ value: item[pr], label: item[pr] }))
}

